'use strict';

var aviarySizes = require('../../../../../../../../../_virtual/aviarySizes.cjs');

var hasRequiredAviarySizes;

function requireAviarySizes () {
	if (hasRequiredAviarySizes) return aviarySizes.__exports;
	hasRequiredAviarySizes = 1;

	var AVIARY_SIZES = /*#__PURE__*/ function(AVIARY_SIZES) {
	    AVIARY_SIZES["none"] = "none";
	    AVIARY_SIZES["xxsmall"] = "xxsmall";
	    AVIARY_SIZES["xsmall"] = "xsmall";
	    AVIARY_SIZES["small"] = "small";
	    AVIARY_SIZES["medium"] = "medium";
	    AVIARY_SIZES["large"] = "large";
	    AVIARY_SIZES["xlarge"] = "xlarge";
	    AVIARY_SIZES["xxlarge"] = "xxlarge";
	    return AVIARY_SIZES;
	}({});

	aviarySizes.__exports.AVIARY_SIZES = AVIARY_SIZES;
	
	return aviarySizes.__exports;
}

exports.__require = requireAviarySizes;
//# sourceMappingURL=aviarySizes.cjs.map
